const MANDATORY_PARAMS = [
    'apiGtwUrl',
    'clientId',
    'scope',
    'redirectUri'
];
const assertParam = (config, paramName)=>{
    if (!config[paramName]) {
        throw new Error(`mandatory param ${paramName} is missing in config`);
    }
};
export const validateConfig = (config)=>{
    MANDATORY_PARAMS.forEach((paramName)=>assertParam(config, paramName));
};
